import script from "./ContentIdentifiers.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentIdentifiers.vue?vue&type=script&lang=ts&setup=true"

import "./ContentIdentifiers.vue?vue&type=style&index=0&id=39649665&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39649665"]])

export default __exports__